import { DateConverter } from '@/model/converters/datesConverters';
import { CustomConverter, JsonObject, JsonProperty } from 'json-ts-mapper';
import { AdresseCommandeSAS } from './adresse-commande-sas';
import { LigneCommandeSAS } from './ligne-commande-sas';

@JsonObject
export class CommandeSAS {
  constructor (
    numero?: string,
    date?: Date,
    numTiers?: string,
    adresse?: AdresseCommandeSAS,
    etape?: string,
    lignes?: LigneCommandeSAS[]
  ) {
    this.numero = numero as any;
    this.date = date as any;
    this.numTiers = numTiers as any;
    this.adresse = adresse as any;
    this.etape = etape as any;
    this.lignes = lignes as any;
  }

  @JsonProperty(String)
  numero?: string;

  @JsonProperty(String)
  @CustomConverter(DateConverter)
  date: Date;

  @JsonProperty(String)
  numTiers?: string;

  @JsonProperty(AdresseCommandeSAS)
  adresse?: AdresseCommandeSAS;

  @JsonProperty(String)
  etape?: string;

  @JsonProperty([LigneCommandeSAS])
  lignes?: LigneCommandeSAS[];
}
